import React, { useState } from 'react';
import { fieldPropTypes } from '../../util/proptype-utils';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Använder react-icons för ögonikonen
import styles from './text.module.css'; // Importera login.css (CSS-modul)

const TextInput = ({ input, meta, id, placeholder, type, label = '', extraClasses = '' }) => {
  // State för att hantera lösenordssynlighet
  const [passwordVisible, setPasswordVisible] = useState(false);

  // Toggle-funktion för lösenordssynlighet
  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  };

  // Dynamiskt sätta type beroende på om lösenordet är synligt eller inte
  const inputType = type === 'password' && passwordVisible ? 'text' : type;

  return (
    <label htmlFor={id} className="form-label">
      {label}
      {meta.touched && meta.error && <div className="alert alert-card alert-error">{meta.error}</div>}
      
      <div className={styles.passwordInputWrapper}> {/* Wrapper för input-fältet */}
        <input
          {...input}
          id={id}
          className={`form-control ${extraClasses}`}
          placeholder={placeholder}
          type={inputType}  
        />
        
        {type === 'password' && (
          <button 
            type="button" 
            className={styles.eyeIcon} 
            onClick={togglePasswordVisibility}
          >
            {passwordVisible ? <FaEyeSlash /> : <FaEye />}  {/* Visar ögonikonen */}
          </button>
        )}
      </div>
    </label>
  );
};

TextInput.propTypes = fieldPropTypes;

export default TextInput;
